import * as Sentry from "@sentry/react";
import React from "react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

import { DISABLED_LOGGER, ENVIRONMENT } from "./constants";

const SENTRY_DSN =
  "https://1502026b131045e5b790b55474461082@o258703.ingest.sentry.io/4505551077048320";

const Logger = {
  init: () => {
    if (DISABLED_LOGGER) return;

    Sentry.init({
      dsn: SENTRY_DSN,
      integrations: [
        new Sentry.BrowserTracing({
          routingInstrumentation: Sentry.reactRouterV6Instrumentation(
            React.useEffect,
            useLocation,
            useNavigationType,
            createRoutesFromChildren,
            matchRoutes
          ),
        }),
        new Sentry.BrowserTracing({
          tracePropagationTargets: [
            "localhost",
            /^https:\/\/app\.cobee\.io/,
            /^https:\/\/app\.pre\.cobee\.io/,
          ],
        }),
      ],
      tracesSampleRate: 1.0,
      environment: ENVIRONMENT,
      ignoreErrors: ["Non-Error promise rejection captured"],
    });
  },
  error: (error: any) => {
    if (DISABLED_LOGGER) return;

    Sentry.captureException(error);
  },
};

export { Logger };
